export default "__VITE_ASSET__8CaiPE6I__"